import { Component, OnInit, Input, OnChanges, HostListener } from '@angular/core';
import { DoughnutChartItem } from './dought-item';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.css']
})
export class DoughnutChartComponent implements OnInit, OnChanges {

  @Input()
  items: Array<DoughnutChartItem> = [
    // {name: 'Orange', count: 50, color: 'orange'},
    // {name: 'Apple', count: 25, color: 'red'},
    // {name: 'Pear', count: 15, color: 'green'}
  ];
  pie_drawing_commands = [];
  private _total = 0;
  tooltip_value: string;
  show_tooltip: boolean;
  tooltip_x: number;
  tooltip_y: number;

  constructor() {
  }
  ngOnInit() {
    if (this.items.length > 0) {
      this._total = this.items.map( a => a.count).reduce((x, y) => x + y);
    }
    this.tooltip_value = 'Sample tooltip';
    this.show_tooltip = false;
  }

  ngOnChanges() {
    if (this.items.length > 0) {
      this._total = this.items.map( a => a.count).reduce((x, y) => x + y);
      this.initPathDrawingCommands();
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e) {
    this.tooltip_x = e.pageX;
    this.tooltip_y = e.pageY + 70;
  }

  initPathDrawingCommands() {
    const radius = 80;
    const move_center = 'M60,125 ';
    let startx = radius;
    let starty = 0;
    const arc_common_command = 'a' + radius + ',' + radius + ' 0 0,0 ';
    for (let i = 0; i < this.items.length; i++) {
      const start_line_command = 'l' + startx + ',' + starty;
      let drawing_command = move_center + start_line_command;
      const combined_angle = this.getCombinedAngle(i);
      const x_disp = radius * Math.cos(combined_angle);
      const y_disp = radius * -1 * Math.sin(combined_angle);
      const arc_x = - (startx - x_disp);
      const arc_y = - (starty - y_disp);
      drawing_command = drawing_command + ' ' + arc_common_command + arc_x + ',' + arc_y;
      const comeback_x = -x_disp;
      const comeback_y = -y_disp;
      drawing_command = drawing_command + ' l' + comeback_x + ',' + comeback_y;
      startx = -comeback_x;
      starty = -comeback_y;
      this.pie_drawing_commands.push(drawing_command);

    }
  }

  showToolTip(index) {
    this.tooltip_value = this.items[index].name + ": " + Math.round((100 * (this.items[index].count / this._total))) + '%';
    this.show_tooltip = true;
  }

  hideToolTip(index) {
    this.show_tooltip = false;
  }

  getCombinedAngle(index: number): number {
    const angles =   this.items.map(item => {
      if (item.count === 0) {
        return 0;
      }
      return item.count / this._total;
    }).filter((val, i) => {
      return i <= index;
    }).map(percent => Math.PI * 2.0 * percent);
    console.log(angles);
    return angles.reduce((pv, cv) => pv + cv, 0);
  }

  getPerimeter(radius: number): number {
    return Math.PI * 2 * radius;
  }

  getColor(index: number): string {
    return this.items[index].color;
  }

  getOffset(radius: number, index: number): number {
    let percent = 0;
    for (let i = 0; i < index; i++) {
      percent += ((this.items[i].count) / this._total);
    }
    const perimeter = Math.PI * 2 * radius;
    return perimeter * percent;
  }
  getPercentageForItem(item) {
    // if(item.showAmounts){
    //   console.log(console.log(item.name, this._total, item.count));
    // }
    return Math.round((item.count / this._total) * 100) || 0;
  }

  getDrawingCommands(index: number): string {
    return this.pie_drawing_commands[index];
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/doughnut-chart/doughnut-chart.component.ts